import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthStorage } from './utils/auth-storage';


const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    // <React.StrictMode>
      <App />
    // </React.StrictMode>
  );
};

const initializeApp = async () => {
  const isCompanyRoute = window.location.pathname.startsWith('/main/company/');

  if (isCompanyRoute) {
    await AuthStorage.restoreSessionFromOpenTab();

    if (!AuthStorage.getItem('token')) {
      window.location.replace('/login');
      return;
    }
  }

  renderApp();
};

initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
